import React from "react";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import {titleCase} from "../../../../utils/utils"
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import moment from 'moment';

const useStyles = makeStyles((theme) => ({
  tableStyle: {
    border: "none",
    boxShadow: "none",
  },
  tableText: {
    fontFamily: "Open Sans",
    fontWeight: 'normal',
    fontSize: "12px",
    lineHeight: "16px",
    color: "#141414",
    textAlign: "center",
    margin: "10px",
    padding: "6px",
    minWidth: "120px"
  },
  tableHeader: {
    textAlign: "center",
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontWeight: "normal",
    color: '#6F6F6F',
    fontSize: "14px",
    lineHeight: "19px",
    padding: "6px",
  },
  even: {
    background: "#F3F3F3",
  },
  odd: {
    background: "#FFFFFF",
  },
}));

function WorldBankTable(props) {
  const classes = useStyles();
  useTheme();

  const getClass = (rowIndex) => {
    if (rowIndex % 2 === 0) {
      return classes.even;
    }

    return classes.odd;
  };         

  return (
    <Paper className={classes.tableStyle}>
      <Table style={{ padding: "8px" }}>
        <TableHead>
          <TableRow>
            <TableCell className={classes.tableHeader}>ID</TableCell>
            <TableCell className={classes.tableHeader}>Nome</TableCell>
            <TableCell className={classes.tableHeader}>País</TableCell>
            <TableCell className={classes.tableHeader}>Endereço</TableCell>
            <TableCell className={classes.tableHeader}>Data do Inicio da Sanção</TableCell>
            <TableCell className={classes.tableHeader}>Data do Fim da Sanção</TableCell>
            <TableCell className={classes.tableHeader}>Grounds</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {props.worldBank_data.map((sanction,index) => (
            <TableRow
              key={index}
              className={getClass(index)}
            > 
              <TableCell className={classes.tableText}>
                {titleCase(sanction.id, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.name, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.country, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.address, "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(moment(sanction.sanction_start_date).format("DD/MM/YYYY"), "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(moment(sanction.sanction_final_date).format("DD/MM/YYYY"), "-")}
              </TableCell>
              <TableCell className={classes.tableText}>
                {titleCase(sanction.grounds, "-")}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </Paper>
  );
}

export default WorldBankTable;